import { render, staticRenderFns } from "./clientMoviment.vue?vue&type=template&id=19b5ef7a&scoped=true&"
import script from "./clientMoviment.vue?vue&type=script&lang=js&"
export * from "./clientMoviment.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=19b5ef7a&scoped=true&lang=css&"
import style1 from "./clientMoviment.vue?vue&type=style&index=1&id=19b5ef7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5ef7a",
  null
  
)

export default component.exports